/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ItemSettingsInputEditable } from './item.SettingsInputEditable';
import { ModalGlobal } from '../modal/modal.Global';
import { SearchInput } from '../search/search.Input';
import {
  copyIntoItem,
  createItemFromTemplate,
  deleteItem,
  deleteItemWithChildren,
  update,
} from '../../services/item';
// import { setOpenModales } from '../../store/global';
// import { CalendarSettings } from '../date/calendar.Settings';
// import { getData, getId } from '../../utils/item';
import { isGlobalAdmin } from '../../utils/roles';
import { canUseMjForItem, isMjForItem } from '../../utils/auth';
import {
  getStoredAuthUser,
  hasAccessConfig,
  isUniverseAdmin,
} from '../../utils/auth';
import { removeItem } from '../../store/items';
import axios from 'axios';
import { BtnSimple } from '../form/btn.Simple';
import { ColorsSwatch } from '../form/colorsSwatch';
import {
  DangerZone,
  SettingsInput,
  SettingsRow,
  SettingsSelect,
  SettingsStaticValue,
  WidgetSettingsCollapsibleSection,
  WidgetSettingsRoot,
} from '../form/settings.Widget';
import { Checkbox } from '../form/checkbox';

export const shouldNavigateHomeAfterItemDelete = (item, routeItemId, itemId) =>
  item?.type === 'universe' || routeItemId === itemId;

export const shouldShowCreateFromTemplateAction = item =>
  item?.isTemplate === true;

export const getDeleteItemConfirmationMessage = item => {
  if (item?.type === 'universe') {
    return (
      "Attention : supprimer cet univers supprimera définitivement tous les dossiers, " +
      "tous les items et toutes les fiches qu'il contient. Cette action est irréversible."
    );
  }

  if (item?.type === 'campaign') {
    return (
      "Attention : supprimer ce dossier supprimera définitivement tous les items, " +
      "toutes les fiches et tous les sous-dossiers qu'il contient. Cette action est irréversible."
    );
  }

  return 'Voulez-vous vraiment supprimer cet item ?';
};

export const ItemSettings = props => {
  const { itemId } = props;
  const navigate = useNavigate();
  const { itemId: routeItemId } = useParams();
  const item = useSelector(state => state.items[itemId]);
  const items = useSelector(state => state.items);
  const [selectedItem, setSelectedItem] = useState({});
  const [campaigns, setCampaigns] = useState([]);
  const [universes, setUniverses] = useState([]);
  const [accessUsers, setAccessUsers] = useState({});
  const [accessErrors, setAccessErrors] = useState({});
  const [isCreatingFromTemplate, setIsCreatingFromTemplate] = useState(false);
  const theme = useSelector(state => state.global.theme);
  const canMj = isMjForItem(item, items) || canUseMjForItem(item, items);
  // const [selectedCalendar, setSelectedCalendar] = useState(null);

  const getAllCampaigns = async universeId => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/items/allcampaigns/${universeId}`,
    );
    if (res?.data) {
      // Trier les campagnes par ordre alphabétique
      res.data.sort((a, b) =>
        a.label < b.label ? -1 : a.label > b.label ? 1 : 0,
      );
      setCampaigns(res.data);
    }
  };

  const getUniverses = async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/items/universes`,
    );
    if (res?.data) {
      const mjAccess = window.localStorage.getItem('mj_access');
      const authUser = getStoredAuthUser();
      const authUserId = authUser?._id;
      const allowedUniverses = res.data.filter(universe =>
        isGlobalAdmin()
          ? true
          : hasAccessConfig(universe)
          ? isUniverseAdmin(universe, authUserId)
          : universe?.password === mjAccess,
      );
      allowedUniverses.sort((a, b) =>
        a.label < b.label ? -1 : a.label > b.label ? 1 : 0,
      );
      setUniverses(allowedUniverses);
    }
  };

  const saveThemeToDatabase = newTheme_ => {
    update(`items/${itemId}`, `theme`, newTheme_)
      .catch(error => {
        console.error('Erreur lors de la sauvegarde du thème', error);
      });
  };

  const saveColorToDatabase = newColor => {
    update(`items/${itemId}`, `color`, newColor)
      .catch(error => {
        console.error('Erreur lors de la sauvegarde de la couleur', error);
      });
  };

  useEffect(() => {
    if (item?.universe) {
      getAllCampaigns(item.universe);
    }
  }, [item?.universe]);

  useEffect(() => {
    getUniverses();
  }, []);

  const searchIn = {
    type: false,
    universe: true,
    world: true,
    campaign: false,
  };
  const dispatch = useDispatch();

  const handleCreateFromTemplate = async () => {
    if (!item?._id || isCreatingFromTemplate) {
      return;
    }
    setIsCreatingFromTemplate(true);
    try {
      const result = await createItemFromTemplate(item, item, {
        label: item?.label,
      });
      if (result?.item?._id) {
        navigate(`/item/${result.item._id}`);
      }
    } finally {
      setIsCreatingFromTemplate(false);
    }
  };

  useEffect(() => {
    if (selectedItem._id) {
      copyIntoItem(item, selectedItem);
    }
  }, [selectedItem]);

  const parseUserList = value =>
    (value || '')
      .split(',')
      .map(entry => entry.trim())
      .filter(Boolean);

  const fetchUsers = async ({ usernames = [], ids = [] }) => {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/users/lookup`,
      { usernames, ids }
    );
    return Array.isArray(res?.data?.users) ? res.data.users : [];
  };

  useEffect(() => {
    const ownerId = item?.owner?.toString?.() ?? item?.owner ?? '';
    const ids = [
      ownerId,
      ...(item?.access?.admins || []),
      ...(item?.access?.editors || []),
      ...(item?.access?.readers || []),
    ]
      .map(entry => entry?.toString?.() ?? '')
      .filter(Boolean);
    const missing = ids.filter(id => !accessUsers[id]);
    if (missing.length === 0) return;
    const load = async () => {
      try {
        const users = await fetchUsers({ ids: missing });
        if (users.length === 0) return;
        const map = {};
        users.forEach(user => {
          map[user._id] = user;
        });
        setAccessUsers(prev => ({ ...prev, ...map }));
      } catch {}
    };
    load();
  }, [
    item?.owner,
    item?.access?.admins,
    item?.access?.editors,
    item?.access?.readers,
    accessUsers,
  ]);

  const resolveUsernames = list =>
    Array.isArray(list)
      ? list.map(id => accessUsers[id]?.username || id).join(', ')
      : '';
  const ownerId = item?.owner?.toString?.() ?? item?.owner ?? '';
  const ownerLabel = ownerId
    ? accessUsers[ownerId]?.username || ownerId
    : 'non défini';

  const setAccessListFromUsernames = async (field, value) => {
    const usernames = parseUserList(value);
    if (usernames.length === 0) {
      setAccessErrors(prev => ({ ...prev, [field]: null }));
      update(`items/${itemId}`, field, []);
      return;
    }
    try {
      const users = await fetchUsers({ usernames });
      const found = new Map(
        users.map(user => [user.username.toLowerCase(), user])
      );
      const ids = [];
      const missing = [];
      usernames.forEach(name => {
        const user = found.get(name.toLowerCase());
        if (user) {
          ids.push(user._id);
        } else {
          missing.push(name);
        }
      });
      const map = {};
      users.forEach(user => {
        map[user._id] = user;
      });
      setAccessUsers(prev => ({ ...prev, ...map }));
      setAccessErrors(prev => ({
        ...prev,
        [field]: missing.length ? `Inconnus: ${missing.join(', ')}` : null,
      }));
      update(`items/${itemId}`, field, ids);
    } catch (e) {
      setAccessErrors(prev => ({
        ...prev,
        [field]: 'Erreur de recherche utilisateurs',
      }));
    }
  };
  return (
    <ModalGlobal
      title={`paramètres de ${item?.label}`}
      idToOpen={'editCurrentItem' + itemId}
    >
      <WidgetSettingsRoot>
        <WidgetSettingsCollapsibleSection title='Général' defaultOpen={true}>
          <SettingsRow label='Courte description' dense>
            <ItemSettingsInputEditable
              itemId={itemId}
              initValue={item?.alias}
              type={'alias'}
            />
          </SettingsRow>

          <SettingsRow label='Couleur' dense>
            <ColorsSwatch
              currentColor={item?.color}
              colors={[
                'transparent',
                'primary',
                'secondary-d',
                'red',
                'orange',
                'yellow',
                'lime',
                'green',
                'blue',
                'purple',
                'pink',
              ]}
              onClick={color => saveColorToDatabase(color)}
            />
          </SettingsRow>
          <SettingsRow label='Vue' dense>
            <ItemSettingsInputEditable
              itemId={itemId}
              initValue={item?.view}
              type={'view'}
            />
          </SettingsRow>

          <SettingsRow label='Thème' dense className='items-start'>
            <div className='flex flex-wrap gap-05'>
              <BtnSimple
                sm
                onClick={() => saveThemeToDatabase(theme)}
              >
                Sauvegarder le thème actuel
              </BtnSimple>
              {item?.theme?.[0] && (
                <BtnSimple
                  sm
                  color='primary-d'
                  onClick={() => saveThemeToDatabase(null)}
                >
                  Enlever le thème sauvegardé
                </BtnSimple>
              )}
            </div>
          </SettingsRow>

          {(item.type === 'world' ||
            ((item?.password ?? '') !== '' &&
              item.type !== 'universe' &&
              item.type !== 'campaign')) && (
            <SettingsRow label='Mot de passe' dense>
              <ItemSettingsInputEditable
                itemId={itemId}
                initValue={item?.password}
                type={'password'}
              />
            </SettingsRow>
          )}

          <SettingsRow label='Template' dense className='items-start'>
            <div className='flex flex-col gap-05'>
              <Checkbox
                label='Utiliser comme template'
                value={item?.isTemplate === true}
                onChange={checked =>
                  update(`items/${itemId}`, 'isTemplate', checked === true)
                }
                truncateLabel={false}
              />
              <div className='text-xs text-contrast text-opacity-60'>
                Les items créés depuis ce template clonent les autres templates
                liés et gardent les références vers les items standards.
              </div>
            </div>
          </SettingsRow>
        </WidgetSettingsCollapsibleSection>

        <WidgetSettingsCollapsibleSection
          title='Organisation'
          defaultOpen={false}
        >
          <SettingsRow label='ID' dense>
            <div className='text-sm text-contrast text-opacity-60 font-mono break-all px-1'>
              {itemId}
            </div>
          </SettingsRow>

          <SettingsRow label='Type' dense>
            <ItemSettingsInputEditable
              itemId={itemId}
              initValue={item?.type}
              type={'type'}
            />
          </SettingsRow>

          {item.type !== 'universe' && (
            <SettingsRow label='Univers' dense>
              <SettingsSelect
                onChange={e =>
                  update(`items/${itemId}`, 'universe', e.target.value)
                }
                defaultValue={
                  universes.some(universe => universe._id === item?.universe)
                    ? item?.universe
                    : 'non défini'
                }
              >
                <option value='non défini'>non défini</option>
                {universes.map(universe => (
                  <option
                    key={universe._id}
                    value={universe._id}
                  >
                    {universe.label}
                  </option>
                ))}
              </SettingsSelect>
            </SettingsRow>
          )}
      {/* <div className='flex flex-1 items-center gap-05'>
        <div className='ml-1 font-bold'>Monde</div>
        <ItemSettingsInputEditable
          itemId={itemId}
          initValue={item?.world}
          type={'world'}
        />
      </div> */}
      {/* <div className='flex flex-1 items-center gap-05'>
        <div className='ml-1 font-bold'>Dossier</div>
        <ItemSettingsInputEditable
          itemId={itemId}
          initValue={item?.campaign}
          type={'campaign'}
        />
      </div> */}

          {item.type !== 'campaign' && item.type !== 'universe' && (
            <SettingsRow label='Dossier' dense>
              <SettingsSelect
                onChange={e =>
                  update(`items/${itemId}`, 'campaign', e.target.value)
                }
                defaultValue={
                  campaigns.some(campaign => campaign._id === item?.campaign)
                    ? item?.campaign
                    : 'non défini'
                }
              >
                <option value='non défini'>non défini</option>
                {campaigns.map(campaign => (
                  <option
                    key={campaign._id}
                    value={campaign._id}
                  >
                    {campaign.label}
                  </option>
                ))}
              </SettingsSelect>
            </SettingsRow>
          )}

        </WidgetSettingsCollapsibleSection>

        {(item.type === 'universe' || item.type === 'campaign') && (
          <WidgetSettingsCollapsibleSection
            title='Accès'
            defaultOpen={false}
          >
            <SettingsRow label='Mot de passe legacy' dense>
              <ItemSettingsInputEditable
                itemId={itemId}
                initValue={item?.password}
                type={'password'}
              />
            </SettingsRow>
            <SettingsRow label='Owner' dense>
              <SettingsStaticValue>{ownerLabel}</SettingsStaticValue>
            </SettingsRow>
            {item.type === 'universe' && (
              <>
                <SettingsRow label='Admins univers' dense className='items-start'>
                  <SettingsInput
                    placeholder='usernames séparés par ,'
                    resetValue={resolveUsernames(item?.access?.admins)}
                    onBlur={value =>
                      setAccessListFromUsernames('access.admins', value)
                    }
                  />
                </SettingsRow>
                {accessErrors['access.admins'] && (
                  <div className='text-xs text-secondary'>
                    {accessErrors['access.admins']}
                  </div>
                )}
                <div className='text-xs text-contrast text-opacity-60'>
                  Seuls owner + admins ont accès à l’univers.
                </div>
              </>
            )}

            {item.type === 'campaign' && (
              <>
                <SettingsRow label='Accès dossier' dense>
                  <SettingsSelect
                    onChange={e =>
                      update(
                        `items/${itemId}`,
                        'access.visibility',
                        e.target.value,
                      )
                    }
                    defaultValue={item?.access?.visibility || 'public'}
                  >
                    <option value='public'>public</option>
                    <option value='private'>privé</option>
                  </SettingsSelect>
                </SettingsRow>

                {(item?.access?.visibility || 'public') === 'public' ? (
                  <SettingsRow label='Rôle par défaut' dense>
                    <SettingsSelect
                      onChange={e =>
                        update(
                          `items/${itemId}`,
                          'access.defaultRole',
                          e.target.value,
                        )
                      }
                      defaultValue={item?.access?.defaultRole || 'editor'}
                    >
                      <option value='read'>lecture seule</option>
                      <option value='editor'>éditeur</option>
                    </SettingsSelect>
                  </SettingsRow>
                ) : (
                  <>
                    <SettingsRow label='Admins' dense className='items-start'>
                      <SettingsInput
                        placeholder='usernames séparés par ,'
                        resetValue={resolveUsernames(item?.access?.admins)}
                        onBlur={value =>
                          setAccessListFromUsernames('access.admins', value)
                        }
                      />
                    </SettingsRow>
                    {accessErrors['access.admins'] && (
                      <div className='text-xs text-secondary'>
                        {accessErrors['access.admins']}
                      </div>
                    )}

                    <SettingsRow label='Éditeurs' dense className='items-start'>
                      <SettingsInput
                        placeholder='usernames séparés par ,'
                        resetValue={resolveUsernames(item?.access?.editors)}
                        onBlur={value =>
                          setAccessListFromUsernames('access.editors', value)
                        }
                      />
                    </SettingsRow>
                    {accessErrors['access.editors'] && (
                      <div className='text-xs text-secondary'>
                        {accessErrors['access.editors']}
                      </div>
                    )}

                    <SettingsRow label='Lecteurs' dense className='items-start'>
                      <SettingsInput
                        placeholder='usernames séparés par ,'
                        resetValue={resolveUsernames(item?.access?.readers)}
                        onBlur={value =>
                          setAccessListFromUsernames('access.readers', value)
                        }
                      />
                    </SettingsRow>
                    {accessErrors['access.readers'] && (
                      <div className='text-xs text-secondary'>
                        {accessErrors['access.readers']}
                      </div>
                    )}
                  </>
                )}
              </>
            )}
          </WidgetSettingsCollapsibleSection>
        )}
      {/* <div className='flex flex-1 items-center gap-05'>
        <div className='ml-1 font-bold'>Afficher comme section</div>
        <Checkbox
          label={''}
          value={useAsSection}
          onChange={() => {
            update(`items/${itemId}`, 'dontUseAsSection', useAsSection);
            setUseAsSection(!useAsSection);
          }}
        />
      </div> */}
        <WidgetSettingsCollapsibleSection
          title='Actions'
          defaultOpen={false}
        >
          {shouldShowCreateFromTemplateAction(item) && (
            <SettingsRow label='Template' dense className='items-start'>
              <div className='flex flex-col gap-05'>
                <BtnSimple
                  onClick={handleCreateFromTemplate}
                  className='bg-secondary'
                >
                  {isCreatingFromTemplate
                    ? 'Création...'
                    : 'Créer depuis ce template'}
                </BtnSimple>
                <div className='text-xs text-contrast text-opacity-60'>
                  Crée une nouvelle fiche indépendante en clonant les éléments
                  marqués comme templates.
                </div>
              </div>
            </SettingsRow>
          )}
          <SettingsRow label='Importer depuis' dense className='items-start'>
            <SearchInput
              itemId={itemId}
              searchIn={searchIn}
              callback={itemSelected => setSelectedItem(itemSelected)}
              enableCampaignFilter
              showNavigateIcon={false}
              className={'rounded bg-main bg-opacity-50'}
            />
          </SettingsRow>
        </WidgetSettingsCollapsibleSection>

      {/* {item?.type === 'world' && (
        <div className='flex gap-1 items-center flex-wrap'>
          <div className='ml-1 font-bold'>Calendrier</div>
          {(item?.calendars || []).map((calendarObj, i) => (
            <div
              key={i}
              onClick={() => {
                setSelectedCalendar(getId(calendarObj));
                dispatch(
                  setOpenModales({
                    id: 'editCalendar',
                    open: true,
                  })
                );
              }}
            >
              {getData(calendarObj)?.label}
            </div>
          ))}
          {item?.calendars.length === 0 && (
            <BtnSimple
              onClick={() =>
                dispatch(setOpenModales({ id: 'editCalendar', open: true }))
              }
            >
              nouveau calendrier
            </BtnSimple>
          )}
          <CalendarSettings
            calendarName={'nouveau calendrier'}
            itemId={itemId}
            calendarId={selectedCalendar}
          />
        </div>
      )} */}
        {canMj === true && (
          <DangerZone
            title='Suppression'
            confirmTitle='Suppression'
            confirmText='Supprimer'
            confirmId={'delete' + itemId}
            closeModalId={'editCurrentItem' + itemId}
            message={getDeleteItemConfirmationMessage(item)}
            onConfirm={() => {
              const shouldNavigateHomeAfterDelete =
                shouldNavigateHomeAfterItemDelete(item, routeItemId, itemId);
              if (item?.type === 'campaign') {
                deleteItemWithChildren(item, deletedIds => {
                  (deletedIds || []).forEach(id => {
                    dispatch(removeItem(id));
                  });
                  if (shouldNavigateHomeAfterDelete) {
                    navigate('/');
                  }
                });
                return;
              }

              deleteItem(itemId, deletedIds => {
                (deletedIds || [itemId]).forEach(id => {
                  dispatch(removeItem(id));
                });
                if (shouldNavigateHomeAfterDelete) {
                  navigate('/');
                }
              });
            }}
          />
        )}
      </WidgetSettingsRoot>
    </ModalGlobal>
  );
};
